export default {
    title: 'Password recovery',
    form: {
        fields: {
            phone: {
                label: 'Phone',
                validations: {
                    require: 'this field is required',
                },
            },
            verificationCode: {
                label: 'Last {{codeLength}} numbers',
                validations: {
                    require: 'this field is required',
                },
            },
            password: {
                label: 'New password',
                validations: {
                    require: 'this field is required',
                    repeat: 'Passwords must match',
                },
            },
            repeatPassword: {
                label: 'Repeat the new password',
                validations: {
                    require: 'this field is required',
                    repeat: 'Passwords must match',
                },
            },
        },
        submitButton: 'Войти',
    },
    labels: {
        phoneStep:
            'Enter your phone number, it will receive an incoming call, you do not need to answer',
        verificationStep:
            'You will receive an incoming call to {{phoneNumber}}, enter the last {{codeLength}} numbers',
        createPasswordStep: 'Great :) Now enter your new password',
    },
    buttons: {
        sendCode: 'Send',
        createPassword: 'Change password',
        repeatVerification: "I didn't get the code :(",
        callMeRecovery: 'Reset password via callback',
    },
    messages: {
        successResetPassword: 'Password changed successfully',
        requestResetPassword: `Code re-sent to {{phoneNumber}}`,
    },
    callMe: {
        callMeTitle: 'Password reset via callback',
        form: {
            fields: {
                phone: {
                    label: 'Phone',
                    validations: {
                        require: 'this field is required',
                    },
                },
            },
        },
        labels: {
            phoneStep:
                'Enter your phone number. We will show the number you need to call to confirm the login.',
            callToInfo:
                'Please call from {{login}} to {{callTo}}. After the call, click “I have called”.',
        },
        buttons: {
            sendRequest: 'Get number to call',
            confirmCall: 'I have called',
        },
    },
};
